// Core
import React from 'react';

// Component
import { CardGridProps } from './CardGrid.types';
import { Container } from './CardGrid.style';

function CardGrid({
  children,
  className,
  gap,
  style,
  testId,
}: CardGridProps): JSX.Element {
  return (
    <Container
      className={className}
      testId={testId}
      gap={gap}
      style={style}
    >
      {children}
    </Container>
  );
}

export { CardGrid };
